// extracted by mini-css-extract-plugin
export default {"start-page":"StartPage_start-page__ULH5y","backdrop":"StartPage_backdrop__FJQud","mobile-startBtn":"StartPage_mobile-startBtn__k09v8"};